import Vue from 'vue'
import Vuex from 'vuex'
import http from "@/http/http.js";
import EventBus from '@/eventBus';
import {
    storage,
    Storage
} from "@/storage";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        page:'',
        pageContent:null,
    },
    mutations: {
        setPageContent(state, payload) {
            if (payload!=null) {
                this.state.pageContent = payload;
                EventBus.$emit('page:loaded', payload)
                //this.dispatch('loadApplications')
            } else {
                EventBus.$emit('page:missing', payload)
            }
        },
    },
    actions: {
        loadPage({
            commit
        }, page) {
            http
                .loadPage(page['page'], page['action'], page['params'])
                .then(response => {
                    if (response.ok) {
                        response.json().then(function(data) {
                            commit('setPageContent',data);
                        })
                    } else {
                        commit('setPageContent', response)
                    }
                })
                .catch(error => console.log(error));
        },
    },
    getters: {
        isLogged(state) {
            return state.user != null;
        }
    }
})